<script setup lang="ts">
import merge from 'lodash/merge';

interface FormContentMaterial
{
    content: {
        value: {
            text: string;
        };
    };
}

interface Props
{
    modelValue: any;
}

const props = defineProps<Props>();

const emit = defineEmits<{
    'update:modelValue': [value: any];
}>();

const defaults: any = {
    text: ''
};

const form = computed((): FormType<FormContentMaterial> =>
{
    return props.modelValue;
});

onBeforeMount((): void =>
{
    form.value.content.value = merge(defaults, form.value.content.value);
    form.value.file = null;
});

watch(() => form.value.content.value, (value: any): void =>
{
    triggetModel();
}, { deep: true });

const triggetModel = (): void =>
{
    form.value.$errors.clear('content.value.text');
    emit('update:modelValue', form.value);
};
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Treść]]]')" :invalid-feedback="form.$errors.first('content.value.text')" :state="form.$errors.state('content.value.text')" required>
        <RichTextEditor
            :id="seconds('text-' + form.id)"
            v-model="form.content.value.text"
            name="text"
            shortcode
            timeline
        />
    </IdeoFormGroup>
</template>
